export const UPDATE_PREFERENCES = "UPDATE_PREFERENCES";
export const ADMIN_SETTINGS = "ADMIN_SETTINGS";
export const PORTRAIT_SETTINGS = "PORTRAIT_SETTINGS";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const CREATE_CONTENT = "CREATE_CONTENT";
export const SET_USER = "SET_USER";
export const SET_LOGIN = "SET_LOGIN";
export const SET_CONVERSATION = "SET_CONVERSATION";
export const SET_MESSAGES_BY_LANGUAGE = "SET_MESSAGES_BY_LANGUAGE";
export const SET_CONVERSATION_MESSAGES = "SET_CONVERSATION_MESSAGES";
export const SET_GROUP_LIST = "SET_GROUP_LIST";
export const SET_GROUP = "SET_GROUP";


